

import { TruckDriver } from '@/types';
import { 
  createGenericColumns, 
  createCurrencyCell, 
  createDateCell, 
  GenericColumnConfig 
} from '@/shared/components/GenericTableColumns';

/**
 * トラック運転手テーブルのカラム設定
 */
const truckDriversColumnConfigs: GenericColumnConfig<TruckDriver>[] = [
  {
    accessorKey: 'name',
    header: '運転手名',
    sortable: true,
    size: 200,
    cell: (value) => <div className="font-medium">{value}</div>,
  },
  {
    accessorKey: 'daily_rate',
    header: '日当 (円)',
    sortable: true,
    headerAlign: 'right',
    cellAlign: 'right',
    size: 120,
    cell: createCurrencyCell,
  },
  {
    accessorKey: 'created_at',
    header: '登録日時',
    sortable: true,
    size: 150,
    cell: createDateCell,
  },
];

/**
 * トラック運転手マスタデータのカラム定義 (Generic版)
 * 元のcolumns.tsxを置き換える改良版
 */
export const columns = createGenericColumns<TruckDriver>(
  truckDriversColumnConfigs,
  {
    showSelect: true,
    actionMenu: {
      showCopyId: true,
      items: [
        {
          label: '編集',
          onClick: (driver) => {
            // 編集処理は親コンポーネントで実装される
            console.log('Edit driver:', driver.id);
          },
        },
        {
          label: '削除',
          onClick: (driver) => {
            // 削除処理は親コンポーネントで実装される
            console.log('Delete driver:', driver.id);
          },
          variant: 'destructive',
        },
      ],
    },
  }
);

/**
 * カスタムアクションメニュー付きカラムを生成する関数
 */
export function createTruckDriversColumns(actions?: {
  onEdit?: (driver: TruckDriver) => void;
  onDelete?: (driver: TruckDriver) => void;
}) {
  return createGenericColumns<TruckDriver>(
    truckDriversColumnConfigs,
    {
      showSelect: true,
      actionMenu: {
        showCopyId: true,
        items: [
          ...(actions?.onEdit ? [{
            label: '編集',
            onClick: actions.onEdit,
          }] : []),
          ...(actions?.onDelete ? [{
            label: '削除',
            onClick: actions.onDelete,
            variant: 'destructive' as const,
          }] : []),
        ],
      },
    }
  );
}